import type { BulkTransactionResponse } from '@/api/transactions'

/** The toast after a bulk change: what changed, and why any selected rows were left alone. */
export function bulkResultMessage(
  verb: 'Updated' | 'Deleted',
  res: BulkTransactionResponse
): { title: string; detail: string | null } {
  const done =
    res.changed === 0
      ? `Nothing ${verb.toLowerCase()}`
      : `${verb} ${res.changed} transaction${res.changed === 1 ? '' : 's'}`
  if (res.skipped.length === 0) return { title: done, detail: null }

  const byReason = new Map<string, number>()
  for (const s of res.skipped) byReason.set(s.reason, (byReason.get(s.reason) ?? 0) + 1)
  return {
    title: `${done} · ${res.skipped.length} skipped`,
    detail: Array.from(byReason, ([reason, n]) => `${n} — ${reason}.`).join(' '),
  }
}
